export const environment = {
    name: 'prod-euwest1',
    production: true,
    config: {
        server: {
            account: 'https://account.leapest.com',
            bouncer: 'https://account.leapest.com',
            sahara: 'https://my.leapest.com',
            url: 'https://amber.leapest.com',
            apiUrl: 'https://amber.leapest.com/api',
            brandedApiUrl: 'https://amber.leapest.com/domain/api',
            images: 'https://d1urb2jvovgteb.cloudfront.net/solar/images',
            sphinx: 'https://downloads.leapest.com'
        },
        aws: {
            key: 'AKIAWLQHGLXHLW7ANZOM',
            url: 'https://s3.eu-west-1.amazonaws.com',
            uploadsBucket: 'leap-prod-euwest1-uploads'
        }
    }
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts